import { useEffect, useState } from 'react';
import {
  type LocalWorkspaceServerStatus,
  localWorkspaceServerStatus,
  subscribeLocalWorkspaceServerStatus,
} from '@/lib/local-runtime';

/** Reactive view of the local server's workspace server (local profile only). */
export function useLocalWorkspaceServerStatus(): LocalWorkspaceServerStatus | null {
  const [status, setStatus] = useState<LocalWorkspaceServerStatus | null>(() =>
    localWorkspaceServerStatus(),
  );
  useEffect(() => {
    setStatus(localWorkspaceServerStatus());
    return subscribeLocalWorkspaceServerStatus(setStatus);
  }, []);
  return status;
}
